function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapMutations } from 'vuex';
import Tinymce from '@/components/Tinymce/index';
import { signChallengeDetailApi, signChallengeCreateApi, signChallengeUpdateApi } from '@/api/marketing/sign-challenge';
import { defaultFormData, taskItem, formRules, continuousDaysTypeOptions, renewTypeOptions, taskTypeOptions } from './enums';
import { appletListApi } from "@/api/operation/applet";
var operateMaps = {
  add: '新增',
  edit: '编辑',
  copy: '复制',
  detail: '详情'
};
export default {
  components: {
    Tinymce: Tinymce
  },
  data: function data() {
    return {
      backUrl: '/marketing/sign-challenge/list',
      operate: 'add',
      id: '',
      headTabs: [{
        tit: '基础设置',
        name: '1'
      }, {
        tit: '打卡设置',
        name: '2'
      }],
      currentTab: '1',
      appList: [],
      continuousDaysTypeOptions: continuousDaysTypeOptions,
      renewTypeOptions: renewTypeOptions,
      taskTypeOptions: taskTypeOptions,
      loading: false,
      detail: {},
      formData: JSON.parse(JSON.stringify(defaultFormData)),
      ruleValidate: formRules,
      loadingBtn: false,
      taskTab: '0'
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(['mediaDomain'])), {}, {
    operationText: function operationText() {
      return operateMaps[this.operate] || '';
    },
    isDisabled: function isDisabled() {
      return this.operate === 'detail';
    },
    isEdit: function isEdit() {
      return this.operate === 'edit';
    },
    isCopy: function isCopy() {
      return this.operate === 'copy';
    }
  }),
  created: function created() {
    this.operate = this.$route.params.op;
    this.id = this.$route.params.id;
  },
  mounted: function () {
    var _mounted = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            this.getAppList();
            if (this.id && this.id !== '0') {
              this.getDetail(this.id);
            } else {
              this.initData();
            }
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function mounted() {
      return _mounted.apply(this, arguments);
    }
    return mounted;
  }(),
  methods: _objectSpread(_objectSpread({}, mapMutations('menu', ['closeTag'])), {}, {
    objectSpanMethod: function objectSpanMethod(_ref) {
      var row = _ref.row,
        column = _ref.column,
        rowIndex = _ref.rowIndex,
        columnIndex = _ref.columnIndex;
      if (columnIndex === 0) {
        // 仅控制第一列
        var effectDay = row.effectDay,
          taskSort = row.taskSort;
        if (taskSort !== 1) {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
        var count = 0;
        for (var i in this.formData.taskConfigs) {
          var item = this.formData.taskConfigs[i];
          if (item.effectDay === effectDay) {
            count++;
          }
        }
        return {
          rowspan: count,
          colspan: 1
        };
      }
    },
    getDetail: function getDetail(id) {
      var _this = this;
      this.loading = true;
      signChallengeDetailApi(id).then(function (data) {
        _this.initData(data);
        _this.loading = false;
      }).catch(function (res) {
        _this.loading = false;
      });
    },
    initData: function initData(data) {
      if (data) {
        this.detail = data;
        for (var key in data) {
          if (this.formData.hasOwnProperty(key)) {
            this.formData[key] = data[key];
          }
        }
      }
      this.initTaskConfigs(this.formData.continuousDays);
    },
    getAppList: function getAppList() {
      var _this2 = this;
      var params = {
        page: 1,
        limit: 1000
      };
      appletListApi(params).then(function (data) {
        _this2.appList = (data.list || []).map(function (item) {
          item.label = item.appName;
          item.value = item.id;
          return item;
        });
      });
    },
    changeApp: function changeApp(value) {
      var target = this.appList.find(function (item) {
        return item.value === value;
      });
      this.formData.applicationName = (target === null || target === void 0 ? void 0 : target.appName) || '';
    },
    changeContinuousDays: function changeContinuousDays(value) {
      if (this.formData.delayEndDay > value) {
        this.formData.delayEndDay = value;
      }
      this.initTaskConfigs(value);
    },
    changeDelayStartDay: function changeDelayStartDay(value) {
      if (this.formData.delayEndDay < value) {
        this.formData.delayEndDay = value;
      }
    },
    initTaskConfigs: function initTaskConfigs(continuousDays) {
      var _this$formData$taskCo,
        _this3 = this;
      var len = this.formData.taskConfigs.length;
      var diffNum = continuousDays - (((_this$formData$taskCo = this.formData.taskConfigs[len - 1]) === null || _this$formData$taskCo === void 0 ? void 0 : _this$formData$taskCo.effectDay) || 0);
      if (diffNum > 0) {
        var _this$formData$taskCo2;
        var list = Array.from({
          length: diffNum
        }, function (_, i) {
          return _objectSpread(_objectSpread({}, taskItem), {}, {
            taskTitle: '每日打卡',
            effectDay: len + i + 1,
            taskSort: 1,
            activityId: _this3.isEdit ? _this3.id : ''
          });
        });
        (_this$formData$taskCo2 = this.formData.taskConfigs).push.apply(_this$formData$taskCo2, list);
      } else if (diffNum < 0) {
        var i = len - 1;
        // 获取到超过活动天数的下标，如：continuousDays=3, i=4; continuousDays=5, i=6 ...
        for (; i >= 0; i--) {
          if (this.formData.taskConfigs[i].effectDay <= continuousDays + 1) {
            break;
          }
        }
        this.formData.taskConfigs.splice(i);
      }
    },
    addTaskItem: function addTaskItem(row) {
      var i = 0;
      var count = 0;
      for (; i < this.formData.taskConfigs.length; i++) {
        var item = this.formData.taskConfigs[i];
        if (row.effectDay < item.effectDay) {
          break;
        } else if (row.effectDay === item.effectDay) {
          count++;
        }
      }
      if (count >= taskTypeOptions.length) {
        this.$message.warning("\u6BCF\u5929\u6700\u591A\u80FD\u6DFB\u52A0".concat(taskTypeOptions.length, "\u4E2A\u4EFB\u52A1"));
        return;
      }
      this.formData.taskConfigs.splice(i, 0, _objectSpread(_objectSpread({}, taskItem), {}, {
        taskTitle: '打开小程序',
        taskType: 2,
        effectDay: row.effectDay,
        taskSort: count + 1,
        activityId: row.activityId
      }));
    },
    removeTaskItem: function removeTaskItem(index) {
      this.formData.taskConfigs.splice(index, 1);
    },
    modalPicTap: function modalPicTap() {
      var _this4 = this;
      if (this.isDisabled) return;
      this.$modalUpload(function (img) {
        if (!img) return;
        _this4.formData.activityImage = img[0].sattDir;
      }, false, 'content');
    },
    // 上一步
    handleSubmitLast: function handleSubmitLast() {
      this.currentTab = (Number(this.currentTab) - 1).toString();
    },
    // 下一步
    handleSubmitNext: function handleSubmitNext(name) {
      var _this5 = this;
      if (this.isDisabled) {
        this.currentTab = (Number(this.currentTab) + 1).toString();
        return;
      }
      this.$refs[name].validate(function (valid, obj) {
        if (valid) {
          _this5.currentTab = (Number(_this5.currentTab) + 1).toString();
        } else {
          for (var key in obj) {
            var msg = obj[key][0].message;
            return _this5.$message.warning(msg);
          }
        }
      });
    },
    //保存接口数据更新
    getFormData: function getFormData() {
      var data = _objectSpread({}, this.formData);
      var taskObj = {};
      var taskConfigs = this.formData.taskConfigs;
      for (var i = 0; i < taskConfigs.length; i++) {
        var item = taskConfigs[i];
        var effectDay = item.effectDay,
          taskType = item.taskType;
        if (!taskObj[effectDay]) {
          taskObj[effectDay] = [];
        }
        if (taskObj[effectDay].includes(taskType)) {
          this.$message.warning('每种任务类型每天最多可选择一次');
          return false;
        }
        taskObj[effectDay].push(taskType);
        if (!this.checkTask(item)) {
          return false;
        }
      }
      if (this.operate === 'edit') {
        data.id = this.id;
      }
      return data;
    },
    checkTask: function checkTask(item) {
      if (!item.taskTitle) {
        this.$message.warning('请输入任务标题');
        return false;
      }
      if (item.taskType === 2) {
        if (!item.miniProgramAppId) {
          this.$message.warning('请输入小程序APPID');
          return false;
        }
        if (!item.miniProgramUrl) {
          this.$message.warning('请输入页面路径');
          return false;
        }
      }
      return true;
    },
    // 保存
    handleSubmit: function handleSubmit(name) {
      var _this6 = this;
      this.$refs[name].validate(function (valid, obj) {
        if (valid) {
          _this6.postData();
        } else {
          for (var key in obj) {
            var msg = obj[key][0].message;
            return _this6.$message.warning(msg);
          }
        }
      });
    },
    // 新增保存数据
    postData: function postData() {
      var _this7 = this;
      this.loadingBtn = true;
      var data = this.getFormData();
      if (!data) {
        this.loadingBtn = false;
        return;
      }
      var func = this.operate === 'edit' ? signChallengeUpdateApi : signChallengeCreateApi;
      func(data).then(function (res) {
        _this7.$message.success('保存成功');
        _this7.closeSelectedTag();
        _this7.loadingBtn = false;
      }).catch(function (res) {
        _this7.loadingBtn = false;
      });
    },
    isActive: function isActive(route) {
      return route.path === this.$route.path;
    },
    closeSelectedTag: function closeSelectedTag() {
      var _this8 = this;
      var route = this.$route;
      this.$store.dispatch('tagsView/delView', route).then(function () {
        if (_this8.isActive(route)) {
          _this8.closeTag(route);
          _this8.$router.push({
            path: _this8.backUrl
          });
        }
      });
    }
  })
};